export const validadores = {
    validate$c2: function(files, ref) {
      var width = ref[0];
      var height = ref[1];

      var list = [];
      for (var i = 0; i < files.length; i++) {
        // if file is not an image, reject.
        if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
          return false;
        }

        list.push(files[i]);
      }

      return Promise.all(
        list.map(function(file) {
          return validadores.validateImage(file, width, height);
        })
      );
    },
    validateImage: function(file, width, height) {
      var URL = window.URL || window.webkitURL;
      return new Promise(function(resolve) {
        var image = new Image();
        image.onerror = function() {
          return resolve({ valid: false });
        };
        image.onload = function() {
          return resolve({
            valid:
              image.width >= Number(width) && image.height >= Number(height)
          });
        };

        image.src = URL.createObjectURL(file);
      });
    }
}


// WEBPACK FOOTER //
// ./src/helper/validadores.js